import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FormationEntra.css';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionFormationEntra from '../../components/FormationsEntra/IntroSectionFormationEntra/IntroSectionFormationEntra';
import IntroSectionFormationEntra2 from '../../components/FormationsEntra/IntroSectionFormationEntra/IntroSectionFormationEntra2';
import IntroSectionFormationEntra3 from '../../components/FormationsEntra/IntroSectionFormationEntra/IntroSectionFormationEntra3';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import PricingSectionAzureEntra from '../../components/ui/pricing-section-azure-entra';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import ParallaxIMG0 from './../../assets/images/nas-synology-1.png';
import ParallaxIMG2 from './../../assets/images/nas-synology-3.png';
import ParallaxIMG1 from './../../assets/images/nas-synology-3.png';
import ExpertiseSection from '../../components/PrivateCloud/ExpertiseSectionPrivateCloud/ExpertiseSectionPrivateCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData12 from '../../components/Common/IntroSectionBottom/introSectionData12';
import useSectionRefs from '../../hooks/useSectionRefs';
import ContactComponent from '../../components/Common/ContactComponent/ContactComponent';
import TimelineFormationEntra from '../../components/FormationsEntra/TimelineFormationEntra/TimelineFormationEntra';
import BenefitsPrivateCloud from '../../components/PrivateCloud/ServicesSliderPrivateCloud/BenefitsPrivateCloud';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import { contactLinkData } from '../../data/contactLinkData';
import CertificationsSection from '../../components/FormationsEntra/CertificationsSection/CertificationsSection';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';

const FormationsAzure: React.FC = () => {
    const sectionRefs = useSectionRefs();  
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const { t } = useTranslation();
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('formationEntra.header.title', 'Sécurité & Architecture Azure')} 
            subtitle={t('formationEntra.header.subtitle', 'Formation pour administrateur identité et accès')} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionFormationEntra />
      </section>
      <section id="commitment" className="section light commitment-section">
        <IntroSectionFormationEntra3 />
      </section>
      <section id="cloud" className="section dark">
        <IntroSectionFormationEntra2 />
      </section>
      <div className="gradient-bg">
      <section id="start2" className="section dark" ref={sectionRefs.start2}>
          <div className="gradient-bg">
          <PricingSectionAzureEntra openContactModal={handleOpenContactModal} />
          <TimelineFormationEntra />
          <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
          </div>
        </section>
      </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="azureEntra" />
        <Footer />
      </section>
      <ContactComponent 
        isOpen={isContactModalOpen}
        onClose={handleCloseContactModal}
      />
    </div>
  );
};

export default FormationsAzure;
